export default __webpack_public_path__ + "static/media/iv-plast.522871e1.png";